const loginRouters = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/login.vue'),  // 懒加载
    meta: {
      isLogin: true,
      isCorrectPage: true,
      auth: false
    }
  },//登陸
  {
    path: '/forgetPsw',
    name: 'forgetPsw',
    component: () => import('../views/Login/forgetPsw.vue'),  // 懒加载
    meta: {
      isLogin: true,
      isCorrectPage: false,
      auth: false,
      isForget:true,//不需要登录
    },
  },//忘記密碼
  {
    path: '/myDemo',
    name: 'myDemo',
    component: () => import('../views/Login/myDemo.vue'),  // 懒加载
    meta: {
      isLogin: true,
      isCorrectPage: false,
      auth: false,
      isForget:true,//不需要登录
    },
  },//忘記密碼

]

export default loginRouters;